var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.047,
    height: 14.035,
    viewBox: "0 0 14.047 14.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74446",
    "data-name": "Group 74446",
    transform: "translate(-1125.247 -160.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M2.053,14.9h8.8A2.059,2.059,0,0,0,12.9,12.844V8.423a.587.587,0,0,0-1.173,0v4.421a.884.884,0,0,1-.88.887h-8.8a.884.884,0,0,1-.88-.887V4.061a.884.884,0,0,1,.88-.887h4.4A.587.587,0,1,0,6.452,2h-4.4A2.059,2.059,0,0,0,0,4.061v8.783A2.059,2.059,0,0,0,2.053,14.9Z",
    transform: "translate(1125.247 159.434)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M9.119,6.217l-.463,2.12a.586.586,0,0,0,.159.54.609.609,0,0,0,.54.158l2.113-.464a.586.586,0,0,0,.29-.159L17.1,3.065a1.76,1.76,0,0,0,0-2.49,1.8,1.8,0,0,0-2.49,0L9.28,5.928A.586.586,0,0,0,9.119,6.217Zm6.329-4.81a.6.6,0,0,1,.83,0,.592.592,0,0,1,0,.83l-.415.415-.83-.83ZM10.227,6.635,14.2,2.652l.824.826L11.046,7.462,9.99,7.692Z",
    transform: "translate(1121.674 160.228)",
    fill: "#111"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPage);
export default __webpack_public_path__ + "static/media/editPage.b78b6ccca3e87d56aa335159f740b440.svg";
export { ForwardRef as ReactComponent };